import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Building2, ChevronDown, Check } from "lucide-react";
import { useBranch } from "@/contexts/BranchContext";

export default function BranchSwitcher() {
  const { branches, active, setActive } = useBranch();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  if (!active && branches.length === 0) return null;

  return (
    <div className="relative" data-testid="branch-switcher">
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-2 px-3.5 py-2 bg-gradient-to-br from-[#0B1E3F] to-[#102B5E] text-white border border-amber-300/40 hover:border-amber-300 shadow-sm text-xs font-bold tracking-wider transition-colors"
        data-testid="branch-switcher-btn"
      >
        <Building2 size={14} className="text-amber-300" />
        <span className="text-amber-200 uppercase">Branch:</span>
        <span className="text-white font-black truncate max-w-[180px]">{active?.branch_name || "—"}</span>
        <ChevronDown size={12} className="text-amber-300" />
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-[60]" onClick={() => setOpen(false)} />
          <div className="absolute right-0 top-full mt-1 w-72 bg-white border border-slate-200 shadow-lg z-[70]">
            <div className="px-4 py-2 border-b border-slate-100 text-[10px] uppercase tracking-wider text-slate-500 font-bold">
              Switch Branch
            </div>
            <div className="max-h-72 overflow-y-auto">
              {branches.length === 0 ? (
                <div className="p-4 text-xs text-slate-500">No branches yet</div>
              ) : (
                branches.map(b => (
                  <button
                    key={b.id}
                    onClick={() => { setActive(b); setOpen(false); }}
                    className="w-full px-4 py-2.5 text-left hover:bg-slate-50 flex items-center justify-between"
                    data-testid={`branch-option-${b.branch_code}`}
                  >
                    <div className="min-w-0">
                      <div className="text-sm font-bold text-slate-900 truncate">{b.branch_name}</div>
                      <div className="text-[10px] text-slate-500 tabular">
                        {b.branch_code}
                        {b.gst_number && ` · GST ${b.gst_number}`}
                      </div>
                    </div>
                    <div className="flex items-center gap-1.5 ml-2">
                      {b.is_default && <span className="text-[9px] bg-slate-100 text-slate-600 px-1.5 py-0.5 uppercase">Default</span>}
                      {active?.id === b.id && <Check size={14} className="text-[#F97316]" />}
                    </div>
                  </button>
                ))
              )}
            </div>
            <button
              onClick={() => { setOpen(false); navigate("/settings/company"); }}
              className="w-full px-4 py-2.5 border-t border-slate-100 text-[11px] uppercase tracking-wider font-bold text-[#F97316] hover:bg-orange-50"
              data-testid="branch-manage-btn"
            >
              Manage Branches →
            </button>
          </div>
        </>
      )}
    </div>
  );
}
